<template>
  <!-- 司机招募配置对话框 -->
  <el-dialog
    title="配置信息"
    :visible.sync="show"
    :before-close="closeDialog"
    width="80%"
    style="margin: 0 auto"
  >
    <div class="invite">
      <el-form ref="form">
        <div style="display: flex; align-items: center">
          <div style="font-weight: 700; font-size: 18px">
            招募新司机奖励
            <el-tooltip
              class="item"
              effect="dark"
              content="任务周期以月为单位，招募人数每月重置，每档任务每月仅可领取一次奖励，奖励物品下月发放，除余额外奖励物品有效期为一个自然月"
              placement="right"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <el-button
            style="
              display: inline-block;
              margin-left: 20px;
              width: 100px;
              height: 40px;
            "
            type="primary"
            @click="add_isShow = !add_isShow"
            >统计</el-button
          >
        </div>

        <!-- 司机招募司机 -->
        <div class="content-driver">
          <el-form-item label="司机招募司机:">
            <el-switch
              v-model="submit_data_Driver.is_open"
              inactive-text=""
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </el-form-item>
          <el-table
            :data="tableDataDriver"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            :render-header="renderLastHeader"
          >
            <el-table-column prop="" label="招募人数(包含)">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.person_num"
                  placeholder="招募人数"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="" label="奖励余额">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.amount"
                  placeholder="余额"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column prop="" label="奖励表现分">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.monitor_points"
                  placeholder="表现分"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="" label="优享券">
              <template slot-scope="props">
                <el-select
                  :disabled="props.row.isDisabled"
                  v-model="submit_data_Driver.priority_mode_code"
                  placeholder="请选择优享券"
                  clearable
                >
                  <el-option
                    :label="item.name"
                    :value="item.priority_mode_code"
                    v-for="(item, index) in reward_priority"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column prop="" label="优享券数量">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.priority_coupon"
                  placeholder="优享券数量"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
              <template slot-scope="props">
                <el-button
                  type="text"
                  style="color: green"
                  @click="addRules('driver')"
                  >增加</el-button
                >

                <el-button
                  type="text"
                  style="color: red"
                  v-if="tableDataDriver.length > 1"
                  @click="del(props.row, 'driver')"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 对话框底部按钮 -->
          <div
            style="display: flex; justify-content: center; margin-top: 100px"
          >
            <el-button type="primary" @click="onSubmit('Driver')"
              >保存</el-button
            >
          </div>
        </div>

        <!-- 用户招募司机 -->
        <!-- <div class="content-driver">
          <el-form-item label="用户招募司机:">
            <el-switch
              v-model="submit_data_User.is_open"
              inactive-text=""
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </el-form-item>

          <el-table
            :data="tableDataUser"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
          >
            <el-table-column prop="" label="招募人数(包含)">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.person_num"
                  placeholder="招募人数"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="" label="奖励余额">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.amount"
                  placeholder="余额"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column prop="" label="奖励表现分">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.monitor_points"
                  placeholder="表现分"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column
              prop=""
              label="优享券"
              header-align="center"
              align="centers"
              :render-header="renderTypeHeader"
            >
              <template slot-scope="props">
                {{ props.row.priority_mode_code }}{{ props.row }}
              </template>
            </el-table-column>

            <el-table-column prop="" label="优享券数量">
              <template slot-scope="props">
                <el-input
                  v-model="props.row.priority_coupon"
                  placeholder="优享券数量"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
              <template slot-scope="props">
                <el-button
                  type="text"
                  style="color: green"
                  @click="addRules('user')"
                  >增加</el-button
                >

                <el-button
                  type="text"
                  style="color: red"
                   v-if="tableDataDriver.length>1"
                  @click="del(props.row, 'user')"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
 
          <div
            style="display: flex; justify-content: center; margin-top: 100px"
          >
            <el-button type="primary" @click="onSubmit('User')">保存</el-button>
            <el-button @click="closeDialog">关闭</el-button>
          </div>
        </div> -->
      </el-form>
      <!-- 统计组件 -->
      <driverRecruitRewardList :isShow="add_isShow"></driverRecruitRewardList>
    </div>
  </el-dialog>
</template>
<script>
var _this;
// import bus from "@/utils/bus.js";

import driverRecruitRewardList from "./driverRecruitRewardList.vue";

export default {
  props: {
    isShow: Boolean,
  },
  components: {
    driverRecruitRewardList,
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;

      _this.priorityLists();
      _this.getDriverRecruitConf();
    },
    tableDataDriver(newData, oldData) {
      console.log("表格数据改变");
      _this.tableDataDriver[0].isDisabled = false; // 表格数据改变把表格的第一项优享券select变为可用
    },
  },
  data() {
    return {
      show: false,
      reward_priority: [],
      add_isShow: false,

      submit_data_Driver: {
        is_open: "",
        recruit_driver_conf: "",

        priority_mode_code: "",
      },
      submit_rules: {
        recruit_driver_conf: {
          placeholder: "司机招募司机数据项配置",
          rules: {
            required: false,
            message: "所填数据应为整数",
            regulation: "json_number",
            rulesData: 0,
          },
        },
      },

      submit_data_User: {
        is_open: "",
        recruit_driver_conf: "",

        priority_mode_code: "",
      },

      tableDataDriver: [
        {
          person_num: "",
          amount: "0",
          monitor_points: "0",
          priority_coupon: "0",
          priority_mode_code: "",
        },
      ],

      // 表现分表格数据
      tableDataUser: [
        {
          person_num: "",
          amount: "0",
          monitor_points: "0",
          priority_coupon: "0",
          priority_mode_code: "",
        },
      ],

     
      search_data_reward: {
        page: 1,
        limit: 50,

      },
    };
  },
  created() {
    _this = this;
  },

  methods: {
    // 详情接口
    getDriverRecruitConf() {
      _this
        .$post("/recruit/getDriverRecruitConf")
        .then((res) => {
          _this.submit_data_Driver.is_open = res.data.is_open;
          _this.submit_data_Driver.priority_mode_code =
            res.data.result[0].priority_mode_code;

          if (res.data.result.length != 0) {
            _this.tableDataDriver = [];

            for (let i = 0; i < res.data.result.length; i++) {
              _this.tableDataDriver.push({
                isDisabled: i == 0 ? false : true,
                person_num: res.data.result[i].person_num,
                amount: res.data.result[i].amount,
                monitor_points: res.data.result[i].monitor_points,
                priority_coupon: res.data.result[i].priority_coupon,
                priority_mode_code: res.data.result[i].priority_mode_code,
              });
            }
          }
        })
        .catch((err) => {});
    },
    renderTypeHeader(h) {
      // el-table组件:render-header的用法 Function(h, { column, $index })
      return h(
        "el-select",
        {
          // el-select实现下拉框
          on: {
            input: (value) => {
              console.log(val, "val是选择下拉选后选中的值");
              // 随着下拉框选项的不同，文字框里的内容在变，绑定值改变
              _this.submit_data_Driver.priority_mode_code = value;
              change: this.search(value); //文字框里的内容change事件 暂未用到
            },
          },
          props: {
            value: _this.submit_data_Driver.priority_mode_code, // 文字框的内容取决于这个value,如果value不存在，会报错
          },
        },
        [
          // 下拉框里面填充选项，通过_this.reward_priority遍历map,为每一个选项赋值。
          _this.reward_priority.map((item) => {
            return h("el-option", {
              props: {
                value: item.priority_mode_code,
                label: item.name,
              },
            });
          }),
        ]
      );
    },

    search(val) {
      console.log(val, "val");
    },

    // 表头嵌入select
    renderLastHeader(h) {
      // 下拉框内容包裹在一个div里面
      return h(
        "div",
        {
          style: {
            height: "56px",
          },
        },
        [
          h(
            "span",
            {
              // div里面有一个文字提示： 下拉框所属内容
              style: {},
              class: "level-font-class",
            },
            "日志级别"
          ),
          h(
            "el-select",
            {
              // el-select实现下拉框
              on: {
                input: (value) => {
                  // 随着下拉框的不同，文字框里的内容在便
                  this.logLevel = value;
                },
              },
              props: {
                value: this.logLevel, // 文字框的内容取决于这个value,如果value不存在，会报错
              },
            },
            [
              // 下拉框里面填充选项，通过_this.reward_priority遍历map,为每一个选项赋值。
              _this.reward_priority.map((item) => {
                return h("el-option", {
                  props: {
                    value: item.value,
                    label: item.text,
                  },
                });
              }),
            ]
          ),
        ]
      );
    },

    // 获取优享券
    priorityLists() {
      _this
        .$post("/priority/priorityLists", _this.search_data_reward)
        .then((res) => {
          _this.reward_priority = res.data;

          if (
            _this.search_data_reward.page * _this.search_data_reward.limit <
            res.count
          ) {
            _this.search_data_reward.page += 1;
            _this.priorityLists();
          }
        })
        .catch((err) => {});
    },
    del(obj, val) {
      // console.log(obj, "obj");
      if (val == "driver") {
        // 获取对应下标
        var index = _this.tableDataDriver.indexOf(obj);

        this.tableDataDriver.splice(index, 1);
      } else {
        var index = _this.tableDataUser.indexOf(obj);

        this.tableDataUser.splice(index, 1);
      }
    },
    addRules(val) {
      if (val == "driver") {
        this.tableDataDriver.push({
          isDisabled: true, // 点击增加按钮的时候，新增加的数据优享券不可选
          person_num: "",
          amount: "0",
          monitor_points: "0",
          priority_coupon: "0",
          priority_mode_code: "",
        });
      } else {
        this.tableDataUser.push({
          isDisabled: true, // 点击增加按钮的时候，新增加的数据优享券不可选
          person_num: "",
          amount: "0",
          monitor_points: "0",
          priority_coupon: "0",
          priority_mode_code: "",
        });
      }
    },

    // 保存数据方法
    onSubmit(val) {
      let num_array = [];

      for (let i = 0; i < _this.tableDataDriver.length; i++) {
        if (
          _this.tableDataDriver[i].person_num < 0 ||
          _this.tableDataDriver[i].amount < 0 ||
          _this.tableDataDriver[i].monitor_points < 0 ||
          _this.tableDataDriver[i].priority_coupon < 0
        ) {
          _this.$message.error("表单中存在负数");
          return;
        }

        num_array.push(_this.tableDataDriver[i].person_num);
      }

      if ([...new Set(num_array)].length < _this.tableDataDriver.length) {
        _this.$message.error("累计人数存在重复值");

        return;
      }

      // 如果点击增加按钮，不填写数据，表格中招募人数为空则提交数据的时候删除表格这一行
      _this.tableDataDriver = _this.tableDataDriver.filter(function (item) {
        console.log(item.person_num !== "", "item");
        return item.person_num !== "";
      });
      console.log(_this.tableDataDriver, "_this.tableDataDriver2");

      let newArray = _this.tableDataDriver;
      newArray.map((item) => {
        delete item.isDisabled; //用于标记表格第一行优享券可选，其他行不可选
        delete item.priority_mode_code;
         if(item.amount==''){
          item.amount = '0'
        }
         if(item.monitor_points==''){
          item.monitor_points = '0'
        }
         if(item.priority_coupon==''){
          item.priority_coupon = '0'
        }
      });

      // 转化JSON字符串
      _this.submit_data_Driver.recruit_driver_conf = JSON.stringify(newArray);
      console.log(_this.submit_data_Driver.recruit_driver_conf, "提交数据数组");
      console.log(_this.tableDataDriver, "_this.tableDataDriver");
      console.log(_this.submit_data_Driver, "_this.submit_data_Driver");

      _this
        .$post(
          "/recruit/saveRecruitDriverConf",
          _this.submit_data_Driver,
          _this.submit_rules
        )
        .then((res) => {
          if (res.msg == "success") {
            _this.$message.success(res.msg);
          } else {
            _this.$message.error(res.msg);
          }

          _this.getDriverRecruitConf();
        });
    },
    // 关闭方法
    closeDialog() {
      _this.show = false;
      _this.reward_priority = [];
      _this.submit_data_Driver = {
        is_open: "",
        recruit_driver_conf: "",
   
        priority_mode_code: "",
      };
      _this.submit_data_User = {
        is_open: "",
        recruit_driver_conf: "",
    
        priority_mode_code: "",
      };
      _this.tableDataDriver = [
        {
          person_num: "",
          amount: "0",
          monitor_points: "0",
          priority_coupon: "0",
          priority_mode_code: "",
        },
      ];
      _this.tableDataUser = [
        {
          person_num: "",
          amount: "0",
          monitor_points: "0",
          priority_coupon: "0",
          priority_mode_code: "",
        },
      ];
    },
  },
};
</script>

<style scoped>
.content-driver {
  padding: 20px;
  border: 1px solid #ccc;

  border-radius: 10px;
  margin-top: 10px;
}
</style>